import { render } from "./CustomerPanelHeader.vue?vue&type=template&id=a0453be8&scoped=true"
import script from "./CustomerPanelHeader.vue?vue&type=script&lang=js"
export * from "./CustomerPanelHeader.vue?vue&type=script&lang=js"

import "./CustomerPanelHeader.vue?vue&type=style&index=0&id=a0453be8&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0453be8"]])

export default __exports__